import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface SecondarySalesTermAddedState {
    addTerm: boolean;
}
const initialState: SecondarySalesTermAddedState = {
    addTerm: false,
};
export const reducer = {
    "Custom/SecondarySalesRepSaveTerms/CompleteLoad": (draft: Draft<SecondarySalesTermAddedState>, action: SecondarySalesTermAddedState) => {
        draft.addTerm = action.addTerm;
    }
};
export default createTypedReducerWithImmer(initialState, reducer);
